export default __webpack_public_path__ + "assets/images/caf600134d36b2ab349c04138c4ee4f3.svg";